export interface TokenMetadata {
  name: string;
  symbol: string;
  description: string;
  image: string; // Base64 or URL
}

export async function uploadTokenMetadata(metadata: TokenMetadata): Promise<string> {
  // Option 1: Upload to IPFS via Pinata/NFT.Storage
  // Option 2: Upload to Arweave via Bundlr
  // Option 3: Use data URI for small metadata (fallback)

  // For MVP, use data URI:
  const metadataJson = JSON.stringify({
    name: metadata.name,
    symbol: metadata.symbol,
    description: metadata.description,
    image: metadata.image,
  });

  return `data:application/json;base64,${btoa(metadataJson)}`;
}